import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const listStocktakes = async ({
  page = 1,
  pageSize = 25,
  search = '',
  warehouseId,
  status,
  startedBy,
  startedFrom,
  startedTo,
  sortField,
  sortOrder,
} = {}) => {
  const response = await axiosInstance.get(`${API_URL}/stock-takes`, {
    params: {
      page,
      pageSize,
      search,
      warehouseId,
      status,
      startedBy,
      startedFrom,
      startedTo,
      sortField,
      sortOrder,
    },
    paramsSerializer: (params) => {
      const query = new URLSearchParams();
      for (const key in params) {
        const value = params[key];
        if (Array.isArray(value)) {
          value.forEach((v) => query.append(key, v));
        } else if (value !== undefined && value !== null && value !== '') {
          query.append(key, value);
        }
      }
      return query.toString();
    },
  });
  return response.data;
};

export const getStocktake = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/stock-takes/${id}`);
  return response.data;
};

export const createStocktake = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}/stock-takes`, payload);
  return response.data;
};

export const deleteStocktake = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/stock-takes/${id}`);
  return response.data;
};

export const cancelStocktake = async (id, payload = {}) => {
  const response = await axiosInstance.post(`${API_URL}/stock-takes/${id}/cancel`, payload);
  return response.data;
};

export const finaliseStocktake = async (id, payload = {}) => {
  const response = await axiosInstance.post(`${API_URL}/stock-takes/${id}/finalise`, payload);
  return response.data;
};

export const listStocktakeLines = async (stocktakeId, params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/stock-takes/${stocktakeId}/lines`, {
    params,
    paramsSerializer: (queryParams) => {
      const query = new URLSearchParams();
      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') query.append(key, value);
      });
      return query.toString();
    },
  });
  return response.data;
};

export const updateStocktakeLineCount = async (stocktakeId, lineId, countedQty) => {
  const response = await axiosInstance.patch(`${API_URL}/stock-takes/${stocktakeId}/lines/${lineId}`, { countedQty });
  return response.data;
};
